<template>
  <el-container class="homecontainer">
    <el-header class="courseheader">数据结构</el-header>
    <el-main class="elmain">
      <div>
        <div class="markdown-body">
          <markdown-datastructure>
          </markdown-datastructure>
        </div>
      </div>
    </el-main>
  </el-container>

</template>

<script>
  import markdownDatastructure from './mdfiles/datastructure.md'
  export default {
    setup () {

    },
    components: {
      markdownDatastructure
    }
  }
</script>

<style lang="less" scoped>
  .homecontainer {
    height: 100%;
  }

  .courseheader {
    background-color: #333744;
    font-size: 30px;
    color: #fff;
    text-align: center;
    padding-top: 8px;
  }

  .elmain {
    margin-top: 0px;
    margin-left: 16px;
    margin-right: 16px;
    line-height: 25px;
    text-align: left;
  }

  a:link {
    text-decoration: none;
  }
</style>
